import { GET_PRODUCT_FILTERS_REQUEST,
    GET_PRODUCT_FILTERS_SUCCESS,
    GET_PRODUCT_FILTERS_FAILURE,
    RESET_PRODUCT_REVIEWS,
    RESET_PRODUCT_REVIEWS_PAGE,
    GET_PRODUCT_REVIEWS_REQUEST,
    GET_PRODUCT_REVIEWS_SUCCESS,
    GET_PRODUCT_REVIEWS_FAILURE,
    GET_PRODUCT_REVIEW_COMMMENTS_REQUEST,
    GET_PRODUCT_REVIEW_COMMMENTS_SUCCESS,
    GET_PRODUCT_REVIEW_COMMMENTS_FAILURE,
    RESET_PRODUCT_REVIEW_COMMENTS,
    POST_PRODUCT_REVIEW_COMMMENT_REQUEST,
    POST_PRODUCT_REVIEW_COMMMENT_SUCCESS,
    POST_PRODUCT_REVIEW_COMMMENT_FAILURE,
    GET_SINGLE_PRODUCT_REVIEW_REQUEST,
    GET_SINGLE_PRODUCT_REVIEW_SUCCESS,
    GET_SINGLE_PRODUCT_REVIEW_FAILURE,
    RESET_SINGLE_PRODUCT_REVIEW,
    SET_SINGLE_PRODUCT_REVIEW,
    DELETE_PRODUCT_REVIEW_COMMENTS_REQUEST,
    DELETE_PRODUCT_REVIEW_COMMENTS_SUCCESS,
    DELETE_PRODUCT_REVIEW_COMMENTS_FAILURE,
    GET_PRODUCTS_SAMPLE_REQUEST,
    GET_PRODUCTS_SAMPLE_SUCCESS,
    GET_PRODUCTS_SAMPLE_FAILURE } from './constants';
import axios from 'axios';
import { onSuccess,
    onError,
    getResponseData,
    onRequest } from '../../utils/helper';
import { getBaseUrl,
    productLinks } from '../../utils/links';
const CancelToken = axios.CancelToken;

export let getProductReviewsCancelToken = undefined;
export const getProductReviews = (token,
    productId,
    params = null) => {
    return dispatch => {
        if (getProductReviewsCancelToken) getProductReviewsCancelToken();
        dispatch(onRequest(GET_PRODUCT_REVIEWS_REQUEST));
        let url = `${getBaseUrl()}${productLinks.reviews(productId)}`,
            options = {
                url,
                headers: {
                    'Authorization': `Bearer ${token}`
                },
                ...(params && {
                    params
                }),
                cancelToken: new CancelToken((c) => getProductReviewsCancelToken = c)
            };
        return axios(options)
            .then(response => {
                let successData = getResponseData(response);
                if (successData) {
                    dispatch(onSuccess(GET_PRODUCT_REVIEWS_SUCCESS, successData));
                } else {
                    dispatch(onError(GET_PRODUCT_REVIEWS_FAILURE, response.data.errors));
                }
                return successData;
            })
            .catch(error => {
                dispatch(onError(GET_PRODUCT_REVIEWS_FAILURE, error));
                return false;
            })
    }
}

export const resetProductReviews = () => onSuccess(RESET_PRODUCT_REVIEWS);

export const resetProductReviewPage = () => onSuccess(RESET_PRODUCT_REVIEWS_PAGE);

// getting single review
export let getProductSingleReviewCancelToken = undefined;
export const getProductSingleReview = (token,
    productId,
    reviewId) => {
    return dispatch => {
        if (getProductSingleReviewCancelToken) getProductSingleReviewCancelToken();
        dispatch(onRequest(GET_SINGLE_PRODUCT_REVIEW_REQUEST));
        let url = `${getBaseUrl()}${productLinks.singleReview(productId, reviewId)}`,
            options = {
                url,
                headers: {
                    'Authorization': `Bearer ${token}`
                },
                cancelToken: new CancelToken((c) => getProductSingleReviewCancelToken = c)
            };
        return axios(options)
            .then(response => {
                let successData = getResponseData(response);
                if (successData) {
                    dispatch(onSuccess(GET_SINGLE_PRODUCT_REVIEW_SUCCESS, successData));
                } else {
                    dispatch(onError(GET_SINGLE_PRODUCT_REVIEW_FAILURE, response.data.errors));
                }
                return successData;
            })
            .catch(error => {
                dispatch(onError(GET_SINGLE_PRODUCT_REVIEW_FAILURE, error));
                return false;
            })
    }
}

// set product review
export const setSingleReview = (review) => onSuccess(SET_SINGLE_PRODUCT_REVIEW, review);

// resetting single review
export const resetProductSingleReview = () => onSuccess(RESET_SINGLE_PRODUCT_REVIEW);

// getting single review comments
export let getProductReviewCommentsCancelToken = undefined;
export const getProductReviewComments = (token,
    productId,
    reviewId,
    params) => {
    return dispatch => {
        if (getProductReviewCommentsCancelToken) getProductReviewCommentsCancelToken();
        dispatch(onRequest(GET_PRODUCT_REVIEW_COMMMENTS_REQUEST));
        let url = `${getBaseUrl()}${productLinks.reviewComments(productId, reviewId)}`,
            options = {
                url,
                headers: {
                    'Authorization': `Bearer ${token}`
                },
                cancelToken: new CancelToken((c) => getProductReviewCommentsCancelToken = c),
                params
            };
        return axios(options)
            .then(response => {
                let successData = getResponseData(response);
                if (successData) {
                    dispatch(onSuccess(GET_PRODUCT_REVIEW_COMMMENTS_SUCCESS, successData));
                } else {
                    dispatch(onError(GET_PRODUCT_REVIEW_COMMMENTS_FAILURE, response.data.errors));
                }
                return successData;
            })
            .catch(error => {
                dispatch(onError(GET_PRODUCT_REVIEW_COMMMENTS_FAILURE, error));
                return false;
            })
    }
}
// resetting single review comments
export const resetProductReviewComments = () => onSuccess(RESET_PRODUCT_REVIEW_COMMENTS);

// posting single review
export let postProductReviewCommentsCancelToken = undefined;
export const postProductReviewComments = (token,
    productId,
    reviewId,
    data) => {
    return dispatch => {
        if (postProductReviewCommentsCancelToken) postProductReviewCommentsCancelToken();
        dispatch(onRequest(POST_PRODUCT_REVIEW_COMMMENT_REQUEST));
        let url = `${getBaseUrl()}${productLinks.reviewComments(productId, reviewId)}`,
            options = {
                url,
                headers: {
                    'Authorization': `Bearer ${token}`
                },
                data,
                method: 'POST',
                cancelToken: new CancelToken((c) => postProductReviewCommentsCancelToken = c)
            };
        return axios(options)
            .then(response => {
                let successData = getResponseData(response);
                if (successData) {
                    const dataToSend = {
                        reviewId,
                        comment: successData
                    }
                    dispatch(onSuccess(POST_PRODUCT_REVIEW_COMMMENT_SUCCESS, dataToSend));
                } else {
                    dispatch(onError(POST_PRODUCT_REVIEW_COMMMENT_FAILURE, response.data.errors));
                }
                return successData;
            })
            .catch(error => {
                dispatch(onError(POST_PRODUCT_REVIEW_COMMMENT_FAILURE, error));
                return false;
            })
    }
}

// deleting a comment
export let deleteProductReviewCommentCancelToken = undefined;
export const deleteProductReviewComment = (token,
    productId,
    reviewId,
    commentId) => {
    return dispatch => {
        if (deleteProductReviewCommentCancelToken) deleteProductReviewCommentCancelToken();
        dispatch(onRequest(DELETE_PRODUCT_REVIEW_COMMENTS_REQUEST));
        let url = `${getBaseUrl()}${productLinks.singleReviewComment(productId, reviewId, commentId)}`,
            options = {
                url,
                method: 'DELETE',
                headers: {
                    'Authorization': `Bearer ${token}`
                },
                cancelToken: new CancelToken((c) => deleteProductReviewCommentCancelToken = c)
            };
        return axios(options)
            .then(response => {
                let successData = getResponseData(response);
                if (successData) {
                    dispatch(onSuccess(DELETE_PRODUCT_REVIEW_COMMENTS_SUCCESS, {
                        productId,
                        reviewId,
                        commentId
                    }));
                } else {
                    dispatch(onError(DELETE_PRODUCT_REVIEW_COMMENTS_FAILURE, response.data.errors))
                }
            })
            .catch(error => {
                dispatch(onError(DELETE_PRODUCT_REVIEW_COMMENTS_FAILURE, error));
            })
    }
}
export let getProductSampleCancelToken = undefined;
export const getProductSample = (token,
    productId) => {
    return dispatch => {
        if (getProductSampleCancelToken) getProductSampleCancelToken();
        dispatch(onRequest(GET_PRODUCTS_SAMPLE_REQUEST));
        let url = `${getBaseUrl()}${productLinks.getSample(productId)}`,
            options = {
                url,
                headers: {
                    'Authorization': `Bearer ${token}`
                },
                cancelToken: new CancelToken((c) => getProductSampleCancelToken = c)
            };
        return axios(options)
            .then(response => {
                let successData = getResponseData(response);
                if (successData) {
                    dispatch(onSuccess(GET_PRODUCTS_SAMPLE_SUCCESS, successData));
                } else {
                    dispatch(onError(GET_PRODUCTS_SAMPLE_FAILURE, response.data.errors));
                }
                return successData;
            })
            .catch(error => {
                dispatch(onError(GET_PRODUCTS_SAMPLE_FAILURE, error));
                return false;
            })
    }
}
